import { BaseModel } from "@blue-chip/core";
import Project from "./Project";

export default class ProjectUserStar extends BaseModel {
  static get belongsTo() {
    return [Project];
  }
}
